import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import CompanyCoursesProcessTemplate from '@components/CompanyCoursesProcess/CompanyCoursesProcess';
import ContactFormTemplate from '@components/ContactForm/ContactForm';
import EducationTemplate from '@components/Education/Education';
import Exhibitors from '@components/Exhibitors/Exhibitors';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import PartnersTemplate from '@components/Partners/Partners';
import useTranslation from '@hooks/useTranslation';
import DividerTemplate from '@ui/Divider/Divider';
import HeroTemplate from '@ui/Hero/Hero';
import { publicAssets } from '@utils/url.utils';
import { IS_PROD } from '../constants';

interface ICompanyCourses {}

const CompanyCourses: NextPage<ICompanyCourses> = () => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo
                title={t('seo.companyCourses.title')}
                description={t('seo.companyCourses.description')}
                noindex={!IS_PROD}
                nofollow={!IS_PROD}
                openGraph={{
                    images: [{ url: `https://profivzdelavanie.sk${publicAssets('/og-konferencia.png')}` }],
                }}
            />
            <HeaderTemplate />
            <HeroTemplate
                titleKey="companyCourses.hero.title"
                imageKey="company_courses_hero.webp"
                descriptionKey="companyCourses.hero.paragraph"
                listKeys={[
                    'companyCourses.hero.paragraph1',
                    'companyCourses.hero.paragraph2',
                    'companyCourses.hero.paragraph3',
                    'companyCourses.hero.paragraph4',
                ]}
            />
            <CompanyCoursesProcessTemplate />
            <Exhibitors />
            <DividerTemplate />
            <EducationTemplate />
            <DividerTemplate />
            <PartnersTemplate />
            <ContactFormTemplate />
            <FooterTemplate />
        </>
    );
};

export default CompanyCourses;
